import axios from 'axios';
import { ProductTag } from 'types';

export const fetchAllProductTags = (brandId: number) => {
  return axios.get<ProductTag[]>(`/api/brands/${brandId}/products/tags`);
};
